<template>
  <div :key="key" class="dashboard-chart rentabilidad-ordenes">
    <h4>Rentabilidad de Ordenes</h4>
    <vue-svg-gauge
      :start-angle="-110"
      :end-angle="110"
      :value="indicadorPjeActual"
      :separator-step="parseInt(indicadorPjeObjetivo)"
      :min="indicadorPjeMin"
      :max="indicadorPjeMax"
      :gauge-color="indicadorPjeColor"
      :scale-interval="1"/>
    <div class="dashboard-chart-text">
      <!-- <p>Plazo Objetivo: {{ indicadorPlazosObjetivo | numero(2, true) }} días</p> -->
      <p>Pje Actual: {{ indicadorPjeActual | numero(2, true) }} %</p>
      <!-- <p class="description">{{ indicadorPlazosDescripcion }}</p> -->
      <p class="description">Total Órdenes: {{ indicadorOrdenesTotal }}</p>
      <p class="description">Órdenes Rent. Negativa: {{ indicadorOrdenesRentabilidadNegativa }}</p>
      <!-- <p class="description">Presupuestos cerrados los últimos 6 meses</p> -->
      <p class="description">{{ indicadorDescripcion }}</p>
      <p v-if="verOrdenes" 
        class="link" 
        @click.stop="exportarOrdenesRentabilidad"><i class="fa fa-file-excel-o"></i>Exportar Órdenes</p>
      <p v-if="verOrdenes" 
        class="link" 
        @click.stop="exportarOrdenesRentabilidadNegativa"><i class="fa fa-file-excel-o"></i>Exportar Órdenes Rent. Negativa</p>
      <p class="description">Órdenes correspondientes a presupuestos cerrados</p>
    </div>
  </div>
</template>

<script>
import { VueSvgGauge } from 'vue-svg-gauge';

export default {
  components: {
    VueSvgGauge,
  },
  data() {
    return {
      rojo: '#E46651',
      verde: '#41B883',
      amarillo: '#FAFA05',
      rosa: '#FF0187',

      key: 0,
      indicadorPjeActual: 0,
      indicadorPjeObjetivo: parseInt(0),
      indicadorPjeMin: 0,
      indicadorPjeMax: 100,
      indicadorPjeColor:  [ { offset: 0, color: '#E46651' }, { offset: 100, color: '#E46651' } ],
      indicadorPjeDescripcion: '',
      indicadorOrdenesTotal: 0,
      indicadorOrdenesRentabilidadNegativa: 0,
      indicadorDescripcion: '',

      verOrdenes: true
    }
  },
  created() {
  },
  methods: {
    getIndicador() {
      this.$store.dispatch('indicadoresProduccion/getIndicadorRentabilidadOrdenes')
        .then(() => {
          let indicador = this.$store.getters['indicadoresProduccion/indicadorRentabilidadOrdenes']

          this.indicadorPjeActual = +(Math.round(indicador.pjeActual + "e+2")  + "e-2");
          this.indicadorPjeObjetivo = 0; //parseFloat(indicador.plazoObjetivo);
          this.indicadorPjeMax = indicador.pjeActual > 100 ? indicador.pjeActual : 100;
          // this.indicadorPjeDescripcion = indicador.descripcion? indicador.descripcion.trim() : '';
          this.indicadorOrdenesTotal = indicador.ordenesTotal;
          this.indicadorOrdenesRentabilidadNegativa = indicador.ordenesRentabilidadNegativa;
          this.indicadorDescripcion = indicador.indicadorPeriodo? indicador.indicadorPeriodo : '';

          if (parseFloat(indicador.plazoActual) >= parseFloat(indicador.plazoObjetivo)) {
            this.indicadorPjeColor = [{ offset: 0, color: this.verde }, { offset: 100, color: this.verde } ];
          } else if (parseFloat(indicador.plazoActual) >= (parseFloat(indicador.plazoObjetivo) / parseFloat(2))) {
            this.indicadorPjeColor = [{ offset: 0, color: this.amarillo }, { offset: 100, color: this.amarillo } ];
          }
        })
        .finally(() => this.key++);
    },
    exportarOrdenesRentabilidad() {
      this.showSpinner();
      this.$store.dispatch('indicadoresProduccion/getResultadosIndicadorRentabilidadOrdenes')
        .then(() => {
          let exportRpt = Boolean(false); 
          let rptOrdenes = this.$store.getters['indicadoresProduccion/resultados'];

          if (rptOrdenes) {
            if (rptOrdenes.length != 0) {
              exportRpt = Boolean(true);
            }
          }
          if (exportRpt) {
            let title= 'Listado de Ordenes';
            let fileName = 'ordenes-rentabilidad';
            let format = [
              { titulo: 'Nro.Presupuesto', nombre: 'presupuestoNumero', formato: '' },
              { titulo: 'Fecha Registro', nombre: 'fechaRegistro', formato: 'fecha' },
              { titulo: 'Fecha Cierre', nombre: 'fechaCierre', formato: 'fecha' },
              { titulo: 'Cliente', nombre: 'cliente', formato: '' },
              { titulo: 'Acción', nombre: 'accion', formato: '' },
              { titulo: 'Nro.Orden', nombre: 'id', formato: '' },
              { titulo: 'Rubro', nombre: 'rubroTrabajo', formato: '' },
              { titulo: 'Titulo', nombre: 'titulo', formato: '' },
              { titulo: 'Cotizacion Orden', nombre: 'cotizacionOrden', formato: '' },
              { titulo: 'Cotizacion Moneda Presupuesto', nombre: 'monedaCotizacion', formato: '' },
              { titulo: 'Cotizacion', nombre: 'cotizacion', formato: '' },
              { titulo: 'Costo Real', nombre: 'costoReal', formato: '' },
              { titulo: 'Pje.Rentabilidad (Cotiz.)', nombre: 'pjeRentabilidad', formato: '' },
              { titulo: 'Pje.Rentabilidad (Costo)', nombre: 'pjeRentabilidadCosto', formato: '' }
            ];

            this.exportXLS(title, fileName, rptOrdenes, format);
            
          } else {
            this.showErrorMsj('No hay datos para exportar.');
          }
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    exportarOrdenesRentabilidadNegativa() {
      this.showSpinner();
      this.$store.dispatch('indicadoresProduccion/getResultadosIndicadorRentabilidadOrdenesNegativas')
        .then(() => {
          let exportRpt = Boolean(false); 
          let rptOrdenes = this.$store.getters['indicadoresProduccion/resultados'];

          if (rptOrdenes) {
            if (rptOrdenes.length != 0) {
              exportRpt = Boolean(true);
            }
          }
          if (exportRpt) {
            let title= 'Listado de Ordenes';
            let fileName = 'ordenes-rentabilidad-negativa';
            let format = [
              { titulo: 'Nro.Presupuesto', nombre: 'presupuestoNumero', formato: '' },
              { titulo: 'Fecha Registro', nombre: 'fechaRegistro', formato: 'fecha' },
              { titulo: 'Fecha Cierre', nombre: 'fechaCierre', formato: 'fecha' },
              { titulo: 'Cliente', nombre: 'cliente', formato: '' },
              { titulo: 'Acción', nombre: 'accion', formato: '' },
              { titulo: 'Nro.Orden', nombre: 'id', formato: '' },
              { titulo: 'Rubro', nombre: 'rubroTrabajo', formato: '' },
              { titulo: 'Titulo', nombre: 'titulo', formato: '' },
              { titulo: 'Cotizacion Orden', nombre: 'cotizacionOrden', formato: '' },
              { titulo: 'Cotizacion Moneda Presupuesto', nombre: 'monedaCotizacion', formato: '' },
              { titulo: 'Cotizacion', nombre: 'cotizacion', formato: '' },
              { titulo: 'Costo Real', nombre: 'costoReal', formato: '' },
              { titulo: 'Pje.Rentabilidad (Cotiz.)', nombre: 'pjeRentabilidad', formato: '' },
              { titulo: 'Pje.Rentabilidad (Costo)', nombre: 'pjeRentabilidadCosto', formato: '' }
            ];

            this.exportXLS(title, fileName, rptOrdenes, format);
            
          } else {
            this.showErrorMsj('No hay datos para exportar.');
          }
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    }
  }
}
</script>

<style>
  .dashboard-produccion .dashboard-chart .rentabilidad-ordenes h4 {
    margin-bottom: 15px !important;
  }
</style>


